import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { DeletedFile } from 'app/models/deleted-file';
import { FileVersion } from 'app/models/file-version';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';
import { FileExplorerService } from 'app/services/file-explorer.service';
import { WopiService } from 'app/services/wopi.service';
import { finalize } from 'rxjs/operators';
import { StorageService } from 'app/services/storage.service';

@Component({
  selector: 'app-deleted-files',
  templateUrl: './deleted-files.component.html',
  styleUrls: ['./deleted-files.component.scss']
})
export class DeletedFilesComponent implements OnInit {

  unFilteredDeletedFiles: DeletedFile[] = [];
  deletedFiles: DeletedFile[] = [];

  tableLimitSelect = [5, 10, 20, 30, 50, 100];
  selectedTableLimit = 5;
  tableLoadingIndicator: boolean = true;

  filesFilter: string = '';
  pathToRestore: string = '';
  currentStorageName: string = '';

  storageId: number = 0;

  wopiConfig: any = {};

  @ViewChild(DatatableComponent, { static: true }) table: DatatableComponent;

  constructor(public fileService: FileExplorerService, private activatedRoute: ActivatedRoute, private ecoDocsTitleService: EcoDocsTitleService,
    private wopiService: WopiService, private storageService: StorageService) {
      this.wopiService.getWopiConfig().subscribe((c) => this.wopiConfig = c);
  }

  ngOnInit(): void {
    this.ecoDocsTitleService.setTitle( 'Deleted Files', false );
    this.currentStorageName = '';

    this.activatedRoute.params.subscribe(params => {
      this.storageId = +params['id'];
      this.refreshTable();

      this.storageService.getById(this.storageId).subscribe((currentStorage)=> {
        this.currentStorageName = currentStorage.display_name;
      });
    });
  }

  refreshTable() {
    this.tableLoadingIndicator = true;
    this.fileService.listDeletedFiles(this.storageId).subscribe((f) => {
      this.deletedFiles = f;
      this.unFilteredDeletedFiles = f;
      this.updateFilter();
      this.tableLoadingIndicator = false;
    });    
  }

  updateFilter() {
    // filter our data
    const temp = this.unFilteredDeletedFiles.filter((file: DeletedFile) => {

      return (this.filesFilter.length == 0 || file.path.toLowerCase().indexOf(this.filesFilter.toLowerCase()) != -1);
    });

    // update the rows
    this.deletedFiles = temp;

    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

  innerWidth() {
    return window.innerWidth;
  }

  restorePath() {
    this.tableLoadingIndicator = true;
    this.fileService.restoreDeletedFile(this.storageId, this.pathToRestore).subscribe(() => {
      this.tableLoadingIndicator = false;
      this.refreshTable();
      this.pathToRestore = '';
    });
  }

  viewOrDownloadFile(path: string) {
    this.tableLoadingIndicator = true;
    this.fileService.listFileVersions(this.storageId, path).subscribe((fileVersions: FileVersion[]) => {
      let extension: string = path.split('.').pop().toLowerCase();
      /** @todo add images as well to this list? */
      if (extension == 'pdf') {
        window.open(this.fileService.directFileViewURLSpecificVersion(path, this.storageId, fileVersions[1].version_id), '_blank');
      } else if (this.wopiConfig[extension]) {
        this.wopiService.getFileWopiID(this.storageId, path, fileVersions[1].version_id, true).pipe(finalize(() => {
          this.tableLoadingIndicator = false;
        })).subscribe((id) => {
          window.open(`/wopi/view/${extension}/${id}`, '_blank');
        });
      } else {
        this.fileService.downloadFileSpecificVersion( path, this.storageId, fileVersions[1].version_id);
      }  
    });
  }
}
